import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import TextField from 'src/components/text-field';
import Radio from 'src/components/radio';
import Button from 'src/components/button';
import { Modal } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import useFetch from 'src/hooks/useFetch';
import { useDispatch } from 'react-redux';
import { fetchDesignation } from 'src/redux/action/designation.action';
import SlideInModal from 'src/components/slideInModal';

interface IProps {
  handleModal: () => void;
  showModal: boolean;
  editData: boolean;
  editDataId: string;
  setEditData: (val: boolean) => void;
  setEditDataId: (val: string) => void;
  designationEditData: any;
}

const FORM_VALIDATION = Yup.object().shape({
  title: Yup.string()
    .min(3, 'Title must a at least 3 character long')
    .required('Title is required'),
  // authorization: Yup.string().required('Authorization is required'),
});

const AddEdit: React.FC<IProps> = ({
  handleModal,
  showModal,
  editData,
  editDataId,
  setEditData,
  setEditDataId,
  designationEditData,
}) => {
  // const [allowWaiterChecked, setAllowWaiterChecked] = React.useState(
  //   designationEditData?.allowWaiterApp
  // );
  const [allowKDSChecked, setAllowKdsChecked] = React.useState(
    designationEditData ? designationEditData?.allowKDS : false
  );
  const [allowSalesChecked, setAllowSalesChecked] = React.useState(
    designationEditData ? designationEditData?.allowSales : false
  );
  const [allowBackOfficeChecked, setAllowBackOfficeChecked] = React.useState(
    designationEditData ? designationEditData?.allowBackOffice : false
  );
  const [allowOrderChargeChecked , setAllowOrderChargeChecked] = React.useState(
    designationEditData ? designationEditData?.allowOrderCharge : false
  );
  useEffect(() => {
    // setAllowWaiterChecked(designationEditData?.allowWaiterApp);
    setAllowBackOfficeChecked(designationEditData?.allowBackOffice ?? false);
    setAllowSalesChecked(designationEditData?.allowSales ?? false);
    setAllowKdsChecked(designationEditData?.allowKDS ?? false);
    setAllowOrderChargeChecked(designationEditData?.allowOrderCharge ?? false);
  }, [showModal]);

  const initValues = {
    title: editData ? designationEditData?.name : '',
  };
  const dispatch = useDispatch();

  const [errorText, setErrorText] = React.useState('');

  const handleSubmit = async (val: { title: string }) => {
    const payload = {
      id: designationEditData?.id,
      title: val?.title,
      allowKDS: allowKDSChecked,
      allowSales: allowSalesChecked,
      allowBackOffice: allowBackOfficeChecked,
      allowOrderCharge: allowOrderChargeChecked
    };
    try {
      if (editData) {
        await Service.put('/designations/edit', payload);
      } else {
        await Service.post('/designations/create', payload);
      }

      handleModal();
      toastAlert(
        'success',
        `Designation ${val?.title} successfully ${
          editData ? 'edited' : 'added'
        }.`
      );
      dispatch(fetchDesignation() as any);
      setEditData(false);
      setEditDataId('');
    } catch (err: any) {
      setErrorText(err?.response?.data?.message);
    }
  };

  return (
    <>
      {showModal && (
        <SlideInModal
          showModal={showModal}
          title={editData ? 'Edit Designation ' : 'Add Designation'}
          onClick={() => {
            handleModal();
            setErrorText('');
          }}
          errorMsg={errorText}
          className="bg-pure-white z-[9999]"
        >
          <Formik
            initialValues={initValues}
            validateOnMount
            validationSchema={FORM_VALIDATION}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, isValid }) => (
              <Form>
                <TextField
                  label="Title"
                  name="title"
                  defaultValue={editData && designationEditData?.name}
                />

                <div>
                  <h4 className="font-semibold text-sm">Authorization</h4>

                  <div className="flex items-center justify-start gap-6 my-5">
                    <div className="flex gap-2">
                      <input
                        type="checkbox"
                        className="sr-only-peer"
                        checked={allowKDSChecked}
                        onChange={() => setAllowKdsChecked(!allowKDSChecked)}
                      />
                      <h4 className="font-medium text-sm">KDS App</h4>
                    </div>
                    <div className="flex gap-2">
                      <input
                        type="checkbox"
                        className="sr-only-peer"
                        checked={allowSalesChecked}
                        onChange={() =>
                          setAllowSalesChecked(!allowSalesChecked)
                        }
                      />
                      <h4 className="font-medium text-sm">Back office</h4>
                    </div>
                    <div className="flex gap-2">
                      <input
                        type="checkbox"
                        className="sr-only-peer"
                        checked={allowBackOfficeChecked}
                        onChange={() =>
                          setAllowBackOfficeChecked(!allowBackOfficeChecked)
                        }
                      />
                      <h4 className="font-medium text-sm">Waiter App</h4>
                    </div>
                  </div>

                  <div className="flex items-center justify-between my-">
                  <h4 className="font-semibold text-sm">
                    Allow Order Charge
                  </h4>
                  <label className="items-center cursor-pointer toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative ">
                    {/* <Field */}
                    <div
                      className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-500 ${
                        allowOrderChargeChecked
                          ? 'transform translate-x-full bg-primary'
                          : ''
                      }`}
                    ></div>
                    <input
                      type="checkbox"
                      className="sr-only-peer hidden"
                      name=""
                      checked={allowOrderChargeChecked}
                      onChange={() =>
                        setAllowOrderChargeChecked(!allowOrderChargeChecked)
                      }
                    />

                    <span className="ml-5 text-sm font-medium "></span>
                    {/* <div className="w-[26px] h-3.5 bg-border-color peer-focus:outline-none peer-focus:ring-0 rounded-full peer dark:bg-border-color peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[24px] after:border-none after:bg-light-grey after:border after:rounded-full after:h-2.5 after:w-[10px] after:transition-all peer-checked:bg-primary" /> */}
                  </label>
                </div>
                </div>

                <div className=" flex items-center justify-end mt-6">
                  <Button
                    text={editDataId ? 'Update Desigantion' : 'Add designation'}
                    variant="primary"
                    className="px-5"
                    type="submit"
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </SlideInModal>
      )}
    </>
  );
};

export default React.memo(AddEdit);
